import { FormControl, Validators } from '@angular/forms';

chooseOptinCTSTitleController.$inject = [
  '$scope',
  '$mdDialog',
  'AngularOptinsService',
  'AlertingFactory',
  'DropdownItemsFactory',
  'context',
  'elementData',
];

export function chooseOptinCTSTitleController(
  $scope,
  $mdDialog,
  AngularOptinsService,
  AlertingFactory,
  DropdownItemsFactory,
  context,
  elementData
) {
  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.formattedOptins = [];
  $scope.elementData = elementData;
  $scope.optinCTSCtrl = new FormControl('', Validators.required);
  $scope.OptinCTSItems = [];

  init();

  function ok() {
    $scope.elementData = findOptinCTSInList($scope.optinCTSCtrl.value);
    $scope.elementData.scenarioId = context.scenarioId;
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    initOptinTitle();
  }

  function findOptinCTSInList(list) {
    return $scope.formattedOptins.find(optinInList => {
      return (
        optinInList.optin_id === list.optin_id &&
        optinInList.recurring_notification_title === list.recurring_notification_title
      )
    })
  }

  function initOptinTitle() {
    AngularOptinsService.getSentOptinsWithTitle(context.companyId, context.site.id, context.scenarioId).subscribe({
      next: res => {
        $scope.formattedOptins = res.formattedRNOptins;

        $scope.formattedOptins.forEach((optin, index) => {
          optin.index = index;
        });

        $scope.OptinCTSItems = DropdownItemsFactory.buildOptinTitleItems($scope.formattedOptins);

        if ($scope.elementData) {
          const optinCTS = findOptinCTSInList($scope.elementData);
          $scope.optinCTSCtrl.setValue(optinCTS);
        }
      }
    });
  }
}
